import React from "react"

export default function CollectionLog() {
  return <div>CollectionLog</div>
}
